import React from 'react';
import { styled } from '@mui/material/styles';
import type { NavCategory, NavItem } from './navConfig';
import SidebarItem from './SidebarItem';

export type NavItemWithAccess = NavItem & { locked?: boolean };

interface Props {
  category: NavCategory;
  items: NavItemWithAccess[];
  collapsed: boolean;
}

const SectionLabel = styled('div')<{ collapsed: boolean }>(({ theme, collapsed }) => ({
  fontWeight: 600,
  textTransform: 'uppercase',
  color: theme.tokens.sidebarSectionLabel,
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  userSelect: 'none',
  transition: 'padding 100ms ease, font-size 100ms ease',
  fontSize: collapsed ? 9 : 11,
  letterSpacing: collapsed ? 0 : '0.06em',
  textAlign: collapsed ? 'center' : 'left',
  padding: collapsed ? '12px 1px 4px' : '16px 12px 6px',
}));

export default function SidebarCategory({ category, items, collapsed }: Props) {
  if (items.length === 0) return null;

  return (
    <div>
      <SectionLabel collapsed={collapsed}>{category.label}</SectionLabel>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 2, padding: '0 8px' }}>
        {items.map(item => (
          <SidebarItem key={item.id} item={item} collapsed={collapsed} locked={item.locked} />
        ))}
      </div>
    </div>
  );
}
